import React from 'react';
import ArtisanPreferenceModal from '../../Profile/ArtisanPreferenceModal';

const SpecialityModal = ({ showModal, handleClick }) => (
  <ArtisanPreferenceModal
    opened={showModal === 'open'}
    close={handleClick}
    field="speciality"
    title="Modifier votre spécialité"
    description="Choisissez la catégorie de demandes que vous souhaitez recevoir."
    label="Nouvelle spécialité"
    options={[
      { value: 'window', label: 'Menuiserie' },
      { value: 'electricity', label: 'Électricité' },
    ]}
  />
);

export default SpecialityModal;
